import { CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE, CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST, CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS } from "../Types";
import { DcOffLineHost } from "../../config";
import { notification } from "antd";

export const ConfigurExpirationReponseActions = (formId, confExpirationReponseData) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST });

        try {
            const token = localStorage.getItem("token");

            if (!token) {
                throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
            }

            const response = await fetch(`${DcOffLineHost}api/formsettings/${formId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`, 
                },
                body: JSON.stringify(confExpirationReponseData),
            });
            
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.message || "Erreur lors de l'émission de la date d'expiration de réponses");
            }
           
            dispatch({ type: CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS, payload: data });

            notification.success({
                message: data?.message || "Date d'expiration défini avec success",
                duration: 5,
            });
            return data;
        } catch (error) {
            dispatch({ type: CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE, payload: error?.message });

            notification.error({
                message: error?.message || "Erreur lors de l'émission de la date d'expiration de réponses",
            });
        }
    };
};

